module.exports = __webpack_public_path__ + "static/img/1_1.ef1121a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1_1.jpg
// module id = OUbB
// module chunks = 0